import { MessageApiInjection } from "naive-ui/lib/message/src/MessageProvider";

export let message: MessageApiInjection;

export const setMessage = (useMessage: () => MessageApiInjection) => {
  message = useMessage();
};
